const industryOptions = [
    {
        key: 0,
        value: 'Accounting / Auditing Services',
        label: 'Accounting / Auditing Services',
    },
    {
        key: 1,
        value: 'Banking / Financial Services',
        label: 'Banking / Financial Services',
    },
    {
        key: 2,
        value: 'Hospitals / Healthcare',
        label: 'Hospitals / Healthcare',
    },
    {
        key: 3,
        value: 'Logistics / Transportation',
        label: 'Logistics / Transportation',
    },
    {
        key: 4,
        value: 'Energy / Oil / Gas',
        label: 'Energy / Oil / Gas',
    },
    {
        key: 5,
        value: 'Retail / Restaurants',
        label: 'Retail / Restaurants',
    },
    {
        key: 6,
        value: 'Technology / Professional Services',
        label: 'Technology / Professional Services',
    },
    {
        key: 7,
        value: 'Manufacturing',
        label: 'Manufacturing',
    },
    {
        key: 8,
        value: 'Automotive',
        label: 'Automotive',
    },
    {
        key: 9,
        value: 'Travel / Tourism',
        label: 'Travel / Tourism',
    },
    {
        key: 10,
        value: 'Telecom / Communication Services',
        label: 'Telecom / Communication Services',
    },
    {
        key: 11,
        value: 'Pharmaceuticals / Medical Devices',
        label: 'Pharmaceuticals / Medical Devices',
    },
    {
        key: 12,
        value: 'Defense / Aerospace',
        label: 'Defense / Aerospace',
    },
    {
        key: 13,
        value: 'Federal Government',
        label: 'Federal Government',
    },
    {
        key: 14,
        value: 'Higher Education',
        label: 'Higher Education',
    },
    {
        key: 15,
        value: 'Local & State Government',
        label: 'Local & State Government',
    },
    {
        key: 16,
        value: 'Insurance',
        label: 'Insurance',
    },
    {
        key: 17,
        value: 'Real Estate / Property Management',
        label: 'Real Estate / Property Management',
    },
    {
        key: 18,
        value: 'Advertising / Marketing',
        label: 'Advertising / Marketing',
    },
    {
        key: 19,
        value: 'Non-Profit',
        label: 'Non-Profit',
    },
    {
        key: 20,
        value: 'Construction',
        label: 'Construction',
    },
    {
        key: 18,
        value: 'Agriculture / Forestry',
        label: 'Agriculture / Forestry',
    },
]

export default industryOptions
